<template>
  <div class="login-state">
    <transition name="van-slide-up">
      <div
        class="logged-in button shadow"
        v-show="loginIsShow && isLogin && webinarInfo.needLogin !== false"
      >
        <span class="user-name" @click="toUserCenter">{{ userName }}</span>
        <span
          class="icontemp logout-a u-logout"
          @click="logout(webinarInfo)"
        ></span>
      </div>
    </transition>
    <transition name="van-slide-up">
      <div class="wap-share-box" v-show="loginIsShow && posterStatus == '1'">
        <span
          class="icon icontemp shaerd i-shared-wap"
          @click="gotoPoster()"
        ></span>
      </div>
    </transition>
    <div
      class="login-menu"
      @click="toggle()"
      v-if="isLogin || posterStatus == '1'"
    >
      <span class="icontemp more i-more"></span>
    </div>
  </div>
</template>
<script>
import { logout } from "../../common/joinMeeting";
import URL from "../../assets/conf/setting.json";
import { $subscriber } from "fire-wind-water";
import { tc, markType } from "../../common/sbase";
import webinar from "@/services/webinar";
export default {
  name: "LoginState",
  data() {
    return {
      loginIsShow: true,
      webinarInfo: {},
      userInfo: {},
      isLogin: false,
      userName: "",
      posterStatus: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.isLogin = false;
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
        if (data.needLogin == false) {
          this.isLogin = false;
        }
      });
      $subscriber.on("setUserName", data => {
        //        if(!data) return;
        this.isLogin = data && this.webinarInfo.needLogin ? true : false;
        this.userName = data;
        setTimeout(() => {
          this.loginIsShow = false;
        }, 3000);
      });
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
        if (
          data.markCode &&
          data.markCode !== "" &&
          this.webinarInfo.posterShareUrl &&
          this.webinarInfo.posterShareUrl.indexOf("markCode") == -1
        ) {
          this.webinarInfo.posterShareUrl = this.webinarInfo.posterShareUrl.replace(
            "#/",
            "&markCode=" + data.markCode + "#/"
          );
        }
      });
      $subscriber.subscribe("posterStatus", data => {
        this.posterStatus = data;
      });
    },
    logout(webinar) {
      this.isLogin = false;
      return logout(webinar);
    },
    toggle() {
      this.loginIsShow = !this.loginIsShow;
    },
    toUserCenter() {
      window.$sk
        .goto(
          URL.template.usercenterUrl +
            "index.html?tenantId=" +
            this.webinarInfo.tenantId +
            "&schemaId=" +
            this.webinarInfo.schemaId +
            "&memberFormId=" +
            this.webinarInfo.registrationFormId,
          true
        )
        .subscribe(res => {
          window.open(res);
        });
    },
    //海报
    gotoPoster() {
      const userInfo = window.$sk.webinar.get().user;
      if (userInfo.markCode) {
        this.webinarInfo.posterShareUrl = this.webinarInfo.posterShareUrl.replace(
          "#/",
          "&markCode=" + userInfo.markCode + "#/"
        );
      }
      window.$sk.goto(this.webinarInfo.posterShareUrl, true).subscribe(res => {
        window.open(res);
      });
    }
  },

  created() {}
};
</script>
